import { createReducer, on } from '@ngrx/store';
import { initialState } from './agency-officer-store.state';
import * as AgencyOfficerDetailsActions from './agency-officer-store.actions';
import { UpdateOfficerDetailsPermissionsActionResult, ActionType } from '../models/officer-details-action-result.models';

export const AgencyOfficerDetailsReducer = createReducer(
  initialState,
  on(AgencyOfficerDetailsActions.clearState, () => {
    return {
      ...initialState,
    };
  }),
  on(AgencyOfficerDetailsActions.fetchAgencyOfficerDetails, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(AgencyOfficerDetailsActions.fetchAgencyOfficerDetailsSuccess, (state, { agencyOfficerDetailsPermissions }) => {
    return {
      ...state,
      agencyOfficer: agencyOfficerDetailsPermissions,
      isLoading: false,
    };
  }),
  on(AgencyOfficerDetailsActions.updateAgencyOfficerDetails, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(AgencyOfficerDetailsActions.updateAgencyOfficerDetailsSuccess, (state, { agencyOfficerDetails }) => {
    if (state.agencyOfficer?.agencyOfficerDetails) {
      return {
        ...state,
        agencyOfficer: {
          ...state.agencyOfficer,
          agencyOfficerDetails: agencyOfficerDetails,
        },
        actionResult: new UpdateOfficerDetailsPermissionsActionResult(ActionType.UpdateAgencyOfficerDetails, '', true),
        isLoading: false,
      };
    }

    return state;
  }),
  on(AgencyOfficerDetailsActions.updateAgencyOfficerPermissions, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(AgencyOfficerDetailsActions.updateAgencyOfficerPermissionsSuccess, (state, { agencyOfficerPermissions }) => {
    if (state.agencyOfficer?.agencyOfficerPermissions) {
      return {
        ...state,
        agencyOfficer: {
          ...state.agencyOfficer,
          agencyOfficerPermissions: agencyOfficerPermissions,
        },
        actionResult: new UpdateOfficerDetailsPermissionsActionResult(ActionType.UpdateAgencyOfficerPermissions, '', true),
        isLoading: false,
      };
    }

    return state;
  }),
  on(AgencyOfficerDetailsActions.updateAgencyOfficerPhoto, (state) => {
    return {
      ...state,
      isImageLoading: true,
    };
  }),
  on(AgencyOfficerDetailsActions.updateAgencyOfficerPhotoSuccess, (state, { newUrl }) => {
    return state.agencyOfficer
      ? {
          ...state,
          isImageLoading: false,
          agencyOfficer: {
            ...state.agencyOfficer,
            agencyOfficerDetails: {
              ...state.agencyOfficer.agencyOfficerDetails,
              pictureFullPath: newUrl,
            },
          },
        }
      : state;
  }),
  on(AgencyOfficerDetailsActions.updateAgencyOfficerPhotoFailure, (state) => {
    return {
      ...state,
      isImageLoading: false,
    };
  }),
  on(AgencyOfficerDetailsActions.updateAgencyOfficerActionResult, (state, { actionResult }) => {
    return {
      ...state,
      actionResult: actionResult,
      isLoading: false,
    };
  })
);
